module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-46-400-normal.816702e.woff2";